import { getTranslations } from "../../i18n"
import { useLocale } from "../../locale-context"

export function JournalEmptyState() {
	const { locale } = useLocale()
	const t = getTranslations(locale)
	return (
		<div className="text-center text-muted-foreground py-8">
			<div className="font-medium">{t.journal.emptyTitle}</div>
			<div className="text-sm mt-2">{t.journal.emptyDescription}</div>
		</div>
	)
}
